module.exports = __webpack_public_path__ + "img/phoneBg.77eb2b11.png";